export class Guia {
    guia_tipo?:number
    guia_serie?:string
    guia_numero?:string
    fecha?:string
    importe?:number

}
